import { FC } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";

import MenuBar from "shared/MenuBar/MenuBar";

import { useNavigate } from "react-router-dom";
import { useData } from "data/data-provider";

export interface MainNav1Props {
  className?: string;
}

const MainNav1: FC<MainNav1Props> = ({ className = "" }) => {
  const { user, setIsAuthPanelOpen } = useData();
  const navigate = useNavigate();
  return (
    <div
      className={`nc-MainNav1 relative z-10 ${className} max-w-[1450px] mx-auto`}
    >
      <div className="px-4  py-4 lg:py-5 relative flex justify-between items-center">
        <div className="flex justify-start items-center space-x-4 sm:space-x-10">
          <Logo />
        </div>
        <div className="hidden lg:flex items-end">
          <Navigation />
        </div>

        {/* <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
          <HeroSearchForm2MobileFactory />
        </div> */}
        <div className="flex lg:hidden items-center ml-auto">
          {/* <SwitchDarkMode /> */}
          <div className="px-0.5 " />
          <MenuBar />
        </div>
        <div className="hidden lg:flex">
          <div>
            <svg
              width="80"
              height="44"
              viewBox="0 0 80 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_1282_793" fill="white">
                <path d="M0 0H80V44H0V0Z" />
              </mask>
              <path
                d="M79 0V44H81V0H79Z"
                fill="white"
                fill-opacity="0.35"
                mask="url(#path-1-inside-1_1282_793)"
              />
              <g clip-path="url(#clip0_1282_793)">
                <path
                  d="M48.4592 25.57C48.1992 25.27 47.8892 25.035 47.5292 24.865C47.1692 24.695 46.7892 24.61 46.3892 24.61C45.9892 24.61 45.6042 24.695 45.2342 24.865C44.8642 25.035 44.5492 25.27 44.2892 25.57L42.3392 27.58L41.6192 27.19C41.4592 27.09 41.3392 27.02 41.2592 26.98C39.2992 25.68 37.6092 24.1 36.1892 22.24C35.5292 21.4 34.9792 20.5 34.5392 19.54C34.8792 19.22 35.3492 18.74 35.9492 18.1L36.4892 17.56C36.7892 17.28 37.0242 16.95 37.1942 16.57C37.3642 16.19 37.4492 15.79 37.4492 15.37C37.4492 14.95 37.3642 14.55 37.1942 14.17C37.0242 13.79 36.7892 13.46 36.4892 13.18L34.8092 11.44C34.6692 11.32 34.4792 11.12 34.2392 10.84L33.0692 9.67C32.8092 9.37 32.4992 9.14 32.1392 8.98C31.7792 8.82 31.3992 8.745 30.9992 8.755C30.5992 8.765 30.2192 8.85 29.8592 9.01C29.4992 9.17 29.1892 9.39 28.9292 9.67H28.8992L26.8292 11.86C26.4292 12.26 26.1142 12.71 25.8842 13.21C25.6542 13.71 25.5192 14.24 25.4792 14.8C25.3992 16.42 25.6592 17.98 26.2592 19.48C27.3592 22.46 28.9292 25.16 30.9692 27.58C33.6092 30.86 36.8192 33.45 40.5992 35.35C42.2992 36.25 44.1092 36.79 46.0292 36.97L46.4192 37C47.0992 37 47.7492 36.865 48.3692 36.595C48.9892 36.325 49.5192 35.93 49.9592 35.41L49.9892 35.38C50.3292 34.98 50.6892 34.6 51.0692 34.24C51.1892 34.14 51.3692 33.96 51.6092 33.7L51.8792 33.43C52.4792 32.83 52.7892 32.1 52.8092 31.24C52.7892 30.84 52.6992 30.45 52.5392 30.07C52.3792 29.69 52.1492 29.36 51.8492 29.08L48.4592 25.57ZM50.6792 32.26C50.5992 32.34 50.4742 32.46 50.3042 32.62C50.1342 32.78 50.0092 32.91 49.9292 33.01C49.5092 33.41 49.1092 33.84 48.7292 34.3C48.4292 34.62 48.0792 34.87 47.6792 35.05C47.2792 35.23 46.8592 35.31 46.4192 35.29H46.1492C44.4492 35.11 42.8492 34.61 41.3492 33.79C37.7892 32.01 34.7592 29.57 32.2592 26.47C30.3392 24.21 28.8592 21.69 27.8192 18.91C27.2992 17.63 27.0692 16.3 27.1292 14.92C27.1892 14.2 27.4792 13.58 27.9992 13.06L30.0992 10.9C30.3392 10.62 30.6492 10.47 31.0292 10.45C31.3892 10.47 31.6892 10.62 31.9292 10.9C32.1892 11.14 32.5592 11.52 33.0392 12.04L35.3192 14.38C35.6392 14.62 35.7992 14.945 35.7992 15.355C35.7992 15.765 35.6392 16.09 35.3192 16.33C35.1992 16.47 35.0192 16.66 34.7792 16.9C34.2792 17.44 33.7692 17.95 33.2492 18.43L33.2192 18.46C33.0192 18.64 32.8892 18.86 32.8292 19.12C32.7692 19.38 32.7892 19.64 32.8892 19.9L32.9192 19.96C33.4192 21.16 34.0792 22.27 34.8992 23.29C36.4392 25.31 38.2592 27.02 40.3592 28.42C40.5992 28.58 40.8492 28.72 41.1092 28.84L41.2892 28.93C41.5092 29.03 41.6592 29.11 41.7392 29.17L41.7992 29.23C41.9792 29.33 42.1792 29.38 42.3992 29.38C42.7792 29.38 43.0992 29.23 43.3592 28.93L45.4592 26.77C45.6992 26.49 46.0092 26.33 46.3892 26.29C46.7492 26.33 47.0392 26.49 47.2592 26.77H47.2892L50.6792 30.28C50.9792 30.54 51.1292 30.87 51.1292 31.27C51.1292 31.67 50.9792 32 50.6792 32.26ZM41.1692 14.14C41.9892 14.28 42.7592 14.54 43.4792 14.92C44.1992 15.3 44.8492 15.79 45.4292 16.39C46.0092 16.99 46.4842 17.665 46.8542 18.415C47.2242 19.165 47.4792 19.95 47.6192 20.77C47.6592 20.97 47.7542 21.14 47.9042 21.28C48.0542 21.42 48.2392 21.49 48.4592 21.49L48.5792 21.46C48.8192 21.42 49.0042 21.305 49.1342 21.115C49.2642 20.925 49.3092 20.71 49.2692 20.47C49.1092 19.47 48.7992 18.52 48.3392 17.62C47.8792 16.72 47.3042 15.91 46.6142 15.19C45.9242 14.47 45.1392 13.88 44.2592 13.42C43.3792 12.96 42.4492 12.64 41.4692 12.46C41.2492 12.42 41.0442 12.47 40.8542 12.61C40.6642 12.75 40.5492 12.93 40.5092 13.15C40.4692 13.37 40.5142 13.58 40.6442 13.78C40.7742 13.98 40.9492 14.1 41.1692 14.14ZM54.5492 20.23C54.2892 18.59 53.7842 17.03 53.0342 15.55C52.2842 14.07 51.3342 12.735 50.1842 11.545C49.0342 10.355 47.7392 9.375 46.2992 8.605C44.8592 7.835 43.3292 7.31 41.7092 7.03C41.4892 6.99 41.2842 7.04 41.0942 7.18C40.9042 7.32 40.7892 7.505 40.7492 7.735C40.7092 7.965 40.7592 8.175 40.8992 8.365C41.0392 8.555 41.2192 8.67 41.4392 8.71C42.8792 8.97 44.2442 9.44 45.5342 10.12C46.8242 10.8 47.9842 11.67 49.0142 12.73C50.0442 13.79 50.8892 14.985 51.5492 16.315C52.2092 17.645 52.6592 19.04 52.8992 20.5C52.9392 20.7 53.0342 20.87 53.1842 21.01C53.3342 21.15 53.5192 21.22 53.7392 21.22H53.8592C54.0992 21.18 54.2842 21.065 54.4142 20.875C54.5442 20.685 54.5892 20.47 54.5492 20.23Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1282_793">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="matrix(1 0 0 -1 25 37)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className=" mx-4 font-medium">
            <p>Call us for help</p>
            <p className="font-bold">(410) 417-8588</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
